<template>
  <!-- 全摘抄于原官网 -->
  <div class="footer flexaj">
    <div style="width: 1200px;">
      <ul class="foMaincon" style="margin-left: 100px;">
        <li class="width230">
          <h5>{{$t("footer.aboutGlobalCash")}}</h5>
          <span>
            <a :href="link+'foot_about.html'" target="_blank">{{$t("footer.globalCash")}}</a>
          </span>
          <span>
            <a :href="link+'foot_intr.html'" target="_blank">{{$t("footer.introduction")}}</a>
          </span>
          <span>
            <a :href="link+'foot_explain.html'" target="_blank">{{$t("footer.fee")}}</a>
          </span>
          <span>
            <a :href="link+'foot_service.html'" target="_blank">{{$t("footer.condition")}}</a>
          </span>
          <span>
            <a :href="link+'partner.html'" target="_blank">{{$t("footer.partner")}}</a>
          </span>
          <span>
            <a :href="link+'foot_news.html'" target="_blank">{{$t("footer.news")}}</a>
          </span>
        </li>
        <li class="width230">
          <h5>{{$t("footer.safety")}}</h5>
          <span>
            <a :href="link+'foot_statement.html'" target="_blank">{{$t("footer.privacy")}}</a>
          </span>
          <span>
            <a :href="link+'foot_safety.html'" target="_blank">{{$t("footer.cashSafety")}}</a>
          </span>
          <span>
            <a :href="link+'foot_safetyGuide.html'" target="_blank">{{$t("footer.guide")}}</a>
          </span>
          <span>
            <router-link :to="{path: '/help-center'}">{{$t("footer.helpCenter")}}</router-link>
          </span>
          <span>&nbsp;</span>
        </li>
        <li class="width300">
          <h5>{{$t("footer.contact")}}</h5>
          <span>{{$t("footer.hotLines")}}：+86 4006183327&nbsp;&nbsp;&nbsp;+852 3175-7797</span>
          <span>{{$t("footer.email")}}：globalcash@epaylinks.hk</span>
          <span>{{$t("footer.tips")}}</span>
          <span>{{$t("footer.serviceTime")}}：7x24</span>
        </li>
        <li class="width200">
          <h5 align="center">{{$t("footer.globalcashWeChat")}}</h5>
          <p align="center">
            <img src="@/assets/images/home2/gla_code.gif" width="124" height="124" />
          </p>
        </li>
        <li class="ft_copy">
          SVF{{$t("footer.license")}}：SVF0011
          <br />ePayLinks Technology Co.,Ltd. 2012-2020 Copy Right
        </li>
        <li class="ft_copy" style="padding-top: 0;">
          <a style="cursor:pointer;color:#777;" href="http://www.beian.miit.gov.cn">粤ICP备09120482号</a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      link: ""
    };
  },
  methods: {
    toOutLink() {
      // console.log("window", window.location)
      window.location.href = "www.beian.miit.gov.cn";
    }
  },
  mounted() {
    this.link = this.oldLink;
  }
};
</script>
<style lang="scss" scoped>
.footer {
  background: #333;
  float: left;
  width: 100%;
  flex-shrink: 0;
}
.foMaincon {
  width: 100%;
  padding: 30px 0;
}
.foMaincon li {
  float: left;
  display: block;
  border-right: 1px dashed #9d9d9d;
}
.foMaincon li.width230 {
  width: 160px;
  margin-right: 40px;
}
.foMaincon li.width300 {
  width: 390px;
  border: 0;
}
.foMaincon li.width200 {
  width: 127px;
  border: 0;
}
.foMaincon li h5 {
  color: #a6a6a6;
  font-size: 18px;
  float: left;
  width: 100%;
  padding-bottom: 10px;
  font-weight: normal;
}
.foMaincon li span {
  float: left;
  width: 100%;
  line-height: 25px;
  position: relative;
  color: #777;
  font-size: 14px;
}
.foMaincon li span a {
  color: #777;
  font-size: 14px;
}
.foMaincon li a:hover {
  text-decoration: none;
  color: #ccc;
}
.foMaincon li.ft_copy {
  width: 100%;
  color: #777;
  padding-top: 10px;
  border: 0;
}

.ftMain {
  width: 898px;
  padding: 30px;
  margin: 50px auto;
  border: 1px solid #ddd;
  background-color: #fff;
  -webkit-box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
}
.ftMain h1 {
  font-size: 22px;
  color: #333;
  font-weight: 500;
  padding: 0 0 10px 0;
  border-bottom: 1px solid #ccc;
}
.ftMain h1 .ft_return {
  float: right;
  font-size: 14px;
  color: #666;
}
.ftMain p {
  font-size: 14px;
  color: #383838;
}
.ftMain .ftMain_intr {
  text-indent: 2em;
  padding: 20px 0 10px 0;
}
.ftMain_list {
  padding: 10px 0;
}
.ftMain_list h2 {
  font-size: 16px;
  font-weight: 700;
}
.ftMain_list_1 {
  padding: 10px 0 0 0;
}
.ftMain_list_1 li {
  font-size: 14px;
  list-style: inside;
}
.indent2em {
  text-indent: 2em;
  padding: 0 0 30px 0;
}
.indent2em_no_padding {
  text-indent: 2em;
}
.ftMain .ftMain_tec {
  text-align: center;
  font-size: 18px;
  padding: 30px 0 20px 0;
}
.ftMain_tab {
  border: 1px solid #ddd;
  border-bottom: 0px solid #ddd;
  border-right: 0px solid #ddd;
}

.ftMain_tab th {
  background: #f78b22;
  color: #fff;
  height: 40px;
  font-size: 14px;
}
.ftMain_tab td {
  border-bottom: 1px solid #ddd;
  border-right: 1px solid #ddd;
  font-size: 14px;
  text-align: center;
  padding: 8px;
}
.ftMain_tab2 {
  border: 1px solid #ddd;
  border-bottom: 0px solid #ddd;
  border-right: 0px solid #ddd;
}
.ftMain_tab2 th {
  background: #f78b22;
  color: #fff;
  height: 40px;
  font-size: 14px;
}
.ftMain_tab2 td {
  border-bottom: 1px solid #ddd;
  border-right: 1px solid #ddd;
  font-size: 12px;
  text-align: center;
  padding: 8px;
}

.ftMain_tab span {
  font-weight: normal;
  font-size: 14px;
  display: block;
}
.ftMain_tab td .tabNopad td {
  padding: 10px;
}
.ftMain_tab td.tabNopad {
  padding: 0;
  border: 0;
}
.ftMain_font {
  padding: 20px 0 10px 0;
}
.ftMain_font span {
  color: #f67527;
}
.ftMain_tab .weight700 {
  font-weight: 700;
}
.newsTab {
  padding: 20px 0;
}
.newsTab td {
  height: 40px;
  border-bottom: 1px dashed #ccc;
  font-size: 14px;
  color: #666;
}
.newsTab td a {
  color: #666;
}
.newsTab td a:hover {
  color: #ff9600;
  text-decoration: none;
}
.newsTab td .noticeBg {
  background: #f78b22;
  color: #fff;
  border-radius: 2px;
  font-size: 12px;
}
.newsTab td .newsBg {
  background: #de6241;
  color: #fff;
  border-radius: 2px;
  font-size: 12px;
}
.ftMain_list_2 {
  padding-left: 15px;
}
.ftMain_list_2 p {
  padding: 3px 0;
}
.ftMain_list .pt10 {
  padding: 8px 0;
  color: #000;
}
.service {
  color: #f90;
}
</style>